App.namespace('components.locale_manager', () => {
  const LOCALE_COOKIE_NAME = 'tgv_locale_country_code';
  const AVAILABLE_LOCALE = window.__TGV_COUNTRIES_CODES;

  if (!AVAILABLE_LOCALE) {
    throw new Error(`missing window.__TGV_COUNTRIES_CODES got: ${AVAILABLE_LOCALE}`);
  }

  let initialLocale;

  const setLocale = (locale) => {
    if (AVAILABLE_LOCALE.indexOf(locale) === -1) {
      throw new Error(`Tried to read invalid locale: ${locale}`);
    }
    App.es6.shared.cookie.set(LOCALE_COOKIE_NAME, locale, 30);
  };

  // get locale value as they were when the page was open
  const getInitialLocale = () => {
    return initialLocale;
  };

  const getLocale = () => {
    const locale = App.es6.shared.cookie.get(LOCALE_COOKIE_NAME);

    if (!locale) {
      return null;
    }

    if (AVAILABLE_LOCALE.indexOf(locale) === -1) {
      throw new Error(`Tried to use invalid locale: ${locale}`);
    }

    return locale;
  };

  initialLocale = getLocale();

  return {
    setLocale,
    getLocale,
    getInitialLocale,
  };
});
